import React, { useState } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';
import { dayjs } from 'src/libs/dayjs';
import { StyledDatePicker } from 'src/components/molecules/DateRangePicker/StyledDatePicker';

type GoalDateRangePickerProps = {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (startDate: Date | null, endDate: Date | null) => void;
};

export const GoalDateRangePicker: React.FC<GoalDateRangePickerProps> = ({
  startDate,
  endDate,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const formatDateRange = () => {
    if (startDate && endDate) {
      return `${dayjs(startDate).format('DD.MM.YYYY')} - ${dayjs(endDate).format('DD.MM.YYYY')}`;
    }
    if (startDate) {
      return dayjs(startDate).format('DD.MM.YYYY');
    }
    return '';
  };

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    onChange(start, end);
    if (start && end) {
      setIsOpen(false);
    }
  };

  return (
    <FormControl>
      <FormLabel
        fontFamily="marketingPage"
        fontWeight="medium"
        color="text.title"
        mb={2}>
        Select Goal Period
      </FormLabel>
      <Popover
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        isLazy
        matchWidth>
        <PopoverTrigger>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon iconName="calendar" boxSize={5} color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Choose Date"
              value={formatDateRange()}
              readOnly
              cursor="pointer"
              onClick={() => setIsOpen(true)}
              pl={10}
              border="1px solid"
              borderColor="border.box"
              borderRadius="md"
              fontFamily="marketingPage"
              _placeholder={{ color: 'gray.400' }}
              _focus={{
                borderColor: 'icon.green',
                boxShadow: '0 0 0 1px var(--chakra-colors-icon-green)',
              }}
            />
          </InputGroup>
        </PopoverTrigger>
        <PopoverContent p={0} bg="surface.card" w="100%">
          <StyledDatePicker
            selected={startDate ?? undefined}
            onChange={handleDateChange}
            startDate={startDate ?? undefined}
            endDate={endDate ?? undefined}
            selectsRange
            inline
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            monthsShown={1}
          />
        </PopoverContent>
      </Popover>
    </FormControl>
  );
};
